export const Bio = {
  name: "Amrit Raj Rajput",
  roles: [
    "Software Developer",
    "AI Enthusiast",
    "Data Analyst",
  ],
  description:
    "Driven by curiosity and a passion for technology, I thrive in building full-stack applications, contributing to open-source projects, and energizing student communities. Whether it's coding, collaborating, or leading campus tech initiatives, I strive to create impact, share knowledge, and grow with every challenge. I am currently focusing on building AI-powered applications, exploring Generative AI systems, working with real-world datasets, and actively contributing to open source.",
  github: "https://github.com/amritrajrajput",
  resume: "https://linktr.ee/amritrajrajput14",
  linkedin: "https://www.linkedin.com/in/amrit-raj-rajput-569547271/",
  twitter: "https://twitter.com/AmritRajRa4312",
  insta: "https://www.instagram.com/amritrajrajput14/",
};


export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          process.env.PUBLIC_URL + "/assets-port/frontend/icons8-react-native-800.png",
      },
      {
        name: "HTML",
        image:
          process.env.PUBLIC_URL + "/assets-port/frontend/icons8-html-800.png",
      },
      {
        name: "CSS",
        image:
          process.env.PUBLIC_URL + "/assets-port/frontend/icons8-css-800.png",
      },
      {
        name: "JavaScript",
        image:
          process.env.PUBLIC_URL + "/assets-port/frontend/icons8-javascript-800.png",
      },
      {
        name: "Tailwind CSS",
        image:
          process.env.PUBLIC_URL + "/assets-port/frontend/icons8-tailwind-css-800.png",
      },
    ],
  },
{
  title: "Backend",
  skills: [
    {
      name: "Node Js",
      image: process.env.PUBLIC_URL + "/assets-port/backend/icons8-nodejs-800.png",
    },
    {
      name: "MySQL",
      image: process.env.PUBLIC_URL + "/assets-port/backend/icons8-mysql-800.png",
    },
    {
      name: "MongoDB",
      image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    },
    {
      name: "REST API",
      image: process.env.PUBLIC_URL + "/assets-port/backend/api.png",
    },
  ],
}
,
  /*{
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Tenserflow",
        image:
          "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
      },
      {
        name: "Keras",
        image:
          "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://assets.stickpng.com/images/63c2e4c9c4baad4ce22bf9ef.png",
      },
      {
        name: "Sk Learn Kit",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      },
    ],
  }*/



  {
  title: "Professional",
  skills: [
    {
      name: "Leadership",
      image: process.env.PUBLIC_URL + "/assets-port/professional/cropped-image.png",
    },
    {
      name: "Management",
      image: process.env.PUBLIC_URL + "/assets-port/professional/cropped-image%20(1).png",
    },
    {
      name: "Public Relations",
      image: process.env.PUBLIC_URL + "/assets-port/professional/cropped-image%20(2).png",
    },
    {
      name: "Communication",
      image: process.env.PUBLIC_URL + "/assets-port/professional/cropped-image%20(3).png",
    },
    {
      name: "Customer Service",
      image: process.env.PUBLIC_URL + "/assets-port/professional/cropped-image%20(4).png",
    },
    {
      name: "Competitive Analysis",
      image: process.env.PUBLIC_URL + "/assets-port/professional/cropped-image%20(5).png",
    },
    {
      name: "Public Speaking",
      image: process.env.PUBLIC_URL + "/assets-port/professional/cropped-image%20(6).png",
    },
    {
      name: "Teamwork",
      image: process.env.PUBLIC_URL + "/assets-port/professional/cropped-image%20(7).png",
    },
    {
      name: "Problem Solving",
      image: process.env.PUBLIC_URL + "/assets-port/professional/cropped-image%20(8).png",
    }
  ]
}
,
  {
  title: "Others",
  skills: [
    {
      name: "Git",
      image: process.env.PUBLIC_URL + "/assets-port/others/git.png"
    },
    {
      name: "GitHub",
      image: process.env.PUBLIC_URL + "/assets-port/others/github.png"
    },
    {
      name: "VS Code",
      image: process.env.PUBLIC_URL + "/assets-port/others/vs%20code.png"
    },
    {
      name: "Postman",
      image: process.env.PUBLIC_URL + "/assets-port/others/postman.png"
    },
    {
      name: "Figma",
      image: process.env.PUBLIC_URL + "/assets-port/others/figma.png"
    },
    {
      name: "Pandas",
      image: process.env.PUBLIC_URL + "/assets-port/others/panda.png"
    },
    {
      name: "NumPy",
      image: process.env.PUBLIC_URL + "/assets-port/others/numpy.png"
    },
    {
      name: "Generative AI Tools",
      image: process.env.PUBLIC_URL + "/assets-port/others/genai.png"
    }
  ]
},
{
  title: "Programming",
  skills: [
    { name: "Python", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg" },
    { name: "C++", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg" },
    { name: "SQL", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg" }
  ]
},
{
  title: "Data Science",
  skills: [
    { name: "Data Analysis", image: process.env.PUBLIC_URL + "/assets-port/others/panda.png" },
    { name: "Pandas", image: process.env.PUBLIC_URL + "/assets-port/others/panda.png" },
    { name: "NumPy", image: process.env.PUBLIC_URL + "/assets-port/others/numpy.png" },
    { name: "EDA", image: "https://img.icons8.com/color/48/combo-chart--v1.png" },
    { name: "Statistical Analysis", image: "https://img.icons8.com/color/48/statistics.png" },
    { name: "Data Modeling", image: "https://img.icons8.com/color/48/database.png" },
    { name: "Data Visualization", image: "https://img.icons8.com/color/48/scatter-plot.png" }
  ]
},
{
  title: "AI & GenAI",
  skills: [
    { name: "Machine Learning", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/scikitlearn/scikitlearn-original.svg" },
    { name: "Generative AI", image: process.env.PUBLIC_URL + "/assets-port/others/genai.png" },
    { name: "Prompt Engineering", image: "https://img.icons8.com/color/48/artificial-intelligence.png" },
    { name: "LangChain", image: "https://img.icons8.com/color/48/chain.png" },
    { name: "LangGraph", image: "https://img.icons8.com/color/48/graph.png" },
    { name: "AI Analytics", image: "https://img.icons8.com/color/48/artificial-intelligence.png" }
  ]
},
{
  title: "Core CS",
  skills: [
    { name: "DSA", image: "https://img.icons8.com/color/48/code.png" },
    { name: "OOPs", image: "https://img.icons8.com/color/48/object.png" },
    { name: "DBMS", image: "https://img.icons8.com/color/48/data-configuration.png" },
    { name: "Operating Systems", image: "https://img.icons8.com/color/48/linux.png" }
  ]
}
];

export const experiences = [
  {
    id: 0,
    img: process.env.PUBLIC_URL + "/assets-port/experience/gssoc.png",
    role: "Campus Ambassador - GSSoC 2k25",
    company: "GirlScript Summer of Code",
    date: "Jun 2025 - Nov 2025 · 6 mos",
    desc: "Leading outreach for GSSoC 2025 by promoting open-source contributions on campus. Assisted peers with the application process, organized info sessions, and mentored beginners starting their open-source journey.",
    skills: ["Open Source", "Mentorship", "Community Leadership"],
  },
  {
    id: 1,
    img: process.env.PUBLIC_URL + "/assets-port/experience/gssoc.png",
    role: "Contributor",
    company: "GirlScript Summer of Code",
    date: "Oct 2024 – May 2025 · 8 mos",
    desc: "Contributed to beginner-friendly open-source repositories by submitting PRs and collaborating with mentors. Improved Git skills, explored team-based development, and actively participated in code reviews.",
    skills: ["Git", "Open Source", "Collaboration"],
  },
  {
    id: 2,
    img: process.env.PUBLIC_URL + "/assets-port/experience/extreme.png",
    role: "Core Member",
    company: "Galgotias Extreme Club [CSE Dept.]",
    date: "Oct 2024 - Oct 2025 · 1 yr 1 mo",
    desc: "Driving innovation across events, content, and community engagement. Helped organize technical fests, designed creative campaigns, and contributed to building a more tech-aware campus.",
    skills: ["Event Management", "Creative Strategy", "Leadership"],
  },
  {
    id: 3,
    img: process.env.PUBLIC_URL + "/assets-port/experience/gfg.png",
    role: "Management Team Member",
    company: "GeeksforGeeks Student Chapter – GCET",
    date: "Feb 2024 - Oct 2025 · 1 yr 9 mos",
    desc: "Part of the core team executing workshops and coding events. Coordinated logistics, moderated sessions, and worked closely with student coordinators to ensure high-impact learning experiences.",
    skills: ["Team Management", "Event Planning", "Community"],
  },
  {
    id: 4,
    img: process.env.PUBLIC_URL + "/assets-port/experience/gdg.png",
    role: "Member",
    company: "Google Developer Student Club – GCET",
    date: "Dec 2023 - Oct 2025 · 1 yr 11 mos",
    desc: "Actively engaged in tech sessions, hackathons, and speaker series. Gained exposure to real-world tech applications and expanded network through peer collaborations.",
    skills: ["Hackathons", "Tech Talks", "Networking"],
  },
  {
    id: 5,
    img: process.env.PUBLIC_URL + "/assets-port/experience/gdg.png",
    role: "Campus Representative",
    company: "Innova 2024 – GCET",
    date: "Nov 2024 – Dec 2024 · 2 mos",
    desc: "Spearheaded the promotion of GCET’s flagship event 'Innova 2024'. Boosted participation through outreach, handled event queries, and ensured clear communication between teams.",
    skills: ["Promotion", "Public Relations", "Leadership"],
  },
  {
    id: 6,
    img: process.env.PUBLIC_URL + "/assets-port/experience/kotlin.png",
    role: "Crew Member | UDAAN 2025 – Tech & Innovation",
    company: "Kotlin User Group – Gurugram",
    date: "Feb 2025 – Mar 2025 · 2 mos",
    desc: "Volunteered during UDAAN 2025, assisting speakers, guiding attendees, and managing session logistics. Gained exposure to cutting-edge topics in Kotlin, AI, and Salesforce.",
    skills: ["Volunteer Coordination", "AI", "Kotlin", "Salesforce"],
  },
  {
    id: 7,
    img: process.env.PUBLIC_URL + "/assets-port/experience/delhi%20dremin.png",
    role: "Volunteer",
    company: "Delhi Dreamin’",
    date: "Jan 2025 – Mar 2025 · 3 mos",
    desc: "Supported the Salesforce community at Delhi Dreamin’ by assisting in event setup, logistics, and on-ground coordination. Strengthened my network within the Salesforce ecosystem.",
    skills: ["Salesforce", "Volunteering", "Event Support"],
  },
  {
    id: 8,
    img: process.env.PUBLIC_URL + "/assets-port/experience/isp.png",
    role: "Campus Ambassador",
    company: "Internshala Student Program",
    date: "Nov 2024 – Feb 2025 · 4 mos",
    desc: "Acted as the face of Internshala on campus. Hosted info sessions, promoted career opportunities, and helped peers navigate internships and upskilling paths.",
    skills: ["Marketing", "Student Engagement", "Career Development"],
  },
  {
    id: 10,
    img: process.env.PUBLIC_URL + "/assets-port/experience/globaltechtalk.png",
    role: "Volunteer",
    company: "GlobalTechTalks",
    date: "Oct 2024 – Dec 2024 · 3 mos",
    desc: "Managed logistics and outreach for events and hackathons. Encouraged student participation and built meaningful tech conversations within the community.",
    skills: ["Event Logistics", "Community", "Hackathons"],
  },
  {
    id: 11,
    img: process.env.PUBLIC_URL + "/assets-port/experience/devtown.png",
    role: "Campus Ambassador (Intern)",
    company: "DevTown",
    date: "Oct 2024 – Dec 2024 · 3 mos",
    desc: "Promoted DevTown’s webinars and courses, gathered feedback, and served as a bridge between the brand and students. Helped drive event engagement and program awareness.",
    skills: ["Communication", "Campus Marketing", "Event Hosting"],
  },
];

export const education = [
  {
    id: 0,
    img: process.env.PUBLIC_URL + "/assets-port/education/galgotia.png",
    school: "Galgotias College of Engineering and Technology, Greater Noida",
    date: "Nov 2023 - Present",
    grade: "",
    desc: "Currently pursuing a Bachelor of Technology (B.Tech) in Computer Science and Engineering with a specialization in Data Science. Coursework includes Data Structures and Algorithms, Object-Oriented Programming, Java, Python, and Full Stack Web Development. Actively involved in student communities such as Google Developer Student Clubs (GDSC GCET) and Extreme Club, where I contribute to hackathons, tech sessions, and collaborative projects.",
    degree: "Bachelor of Technology - B.Tech, CSE (Data Science)",
  },
  {
    id: 1,
    img: process.env.PUBLIC_URL + "/assets-port/education/Public%20School%20Darbhanga.png",
    school: "Public School, Darbhanga",
    date: "Apr 2021 - Apr 2023",
    grade: "",
    desc: "Completed Class 12 (Intermediate) under the Central Board of Secondary Education (CBSE) with a focus on Physics, Chemistry, Mathematics, and Computer Science. Gained foundational knowledge in logical reasoning, core science principles, and early exposure to programming. Participated in science exhibitions and inter-school competitions.",
    degree: "Intermediate (12th), Science + Computer",
  },
  {
    id: 2,
    img: process.env.PUBLIC_URL + "/assets-port/education/dav.png",
    school: "DAV Public School",
    date: "Apr 2019 - Apr 2021",
    grade: "",
    desc: "Completed Class 10 from DAV Public School affiliated with CBSE. Built strong fundamentals in Mathematics, Science, and English. Actively took part in school-level quizzes, Olympiads, and tech-related clubs, which sparked my early interest in coding and innovation.",
    degree: "Matriculation (10th), CBSE",
  },
];


export const projects = [
  {
    id: 0,
    title: "Kisaan Mitra – Market Linkage Platform 🌾",
    date: "Jan 2025 - Present",
    description:
      "Kisaan Mitra is a web-based market linkage platform for small-scale producers and buyers. The platform streamlines agricultural commerce, eliminates intermediaries, and ensures fair pricing. Features include direct market access, real-time price analytics, secure messaging, product listings, and a responsive design.",
    image: process.env.PUBLIC_URL + "/assets-port/project/kisan%20mitra.png",
    tags: [
      "market linkage",
      "agriculture",
      "farmers",
      "HTML",
      "CSS",
      "JavaScript",
      "Local Storage",
      "responsive design",
      "web app",
      "direct commerce"
    ],
    category: "web app",
    github: "https://github.com/amritrajrajput/kissan-mitra",
    webapp: "",
    member: [],
  },
  {
    id: 1,
    title: "BHARAT ODYSSEY ✨",
    date: "Sep 2024 - Present",
    description:
      "Bharat Odyssey is a centralized ticket booking and travel platform for India tourism. It offers seamless booking for attractions, cultural insights, and curated recommendations for travelers. Features: ticket booking, destination guides, must-visit lists, responsive UI.",
    image: process.env.PUBLIC_URL + "/assets-port/project/bharta%20odessay.png",
    tags: [
      "India travel",
      "ticket booking",
      "tourism",
      "culture",
      "attractions",
      "responsive UI",
      "web app",
      "recommendations",
      "Bharat Odyssey"
    ],
    category: "web app",
    github: "",
    webapp: "",
    member: [],
  },
  {
    id: 2,
    title: "Portfolio Website",
    date: "Aug 2024 - Present",
    description:
      "Personal portfolio website showcasing web development skills, projects, and experience. Optimized for SEO and fast performance. Built with React, HTML, CSS, and JavaScript.",
    image: process.env.PUBLIC_URL + "/assets-port/project/portfolio.png",
    tags: [
      "portfolio",
      "web developer",
      "React",
      "HTML",
      "CSS",
      "JavaScript",
      "SEO",
      "personal website",
      "resume"
    ],
    category: "web app",
    github: "https://github.com/amritrajrajput/portfolio",
    webapp: "https://amritrajrajput.github.io/portfolio",
    member: [],
  },
  {
    id: 3,
    title: "Navigo Bharat (AI Job Market Advisor)",
    date: "",
    description:
      "Built an AI-powered career recommendation system using real-time data + LLMs for job insights. Extracted resume insights using PDF parsing to provide highly personalized AI-driven recommendations.",
    image: "https://img.freepik.com/free-vector/job-interview-conversation_74855-7566.jpg?w=826&t=st=170845345~exp=170845405~hmac=a40498b826e7a221f1d1dc0f49cb8199b0c8b",
    tags: [
      "Python",
      "Streamlit",
      "LangChain",
      "Gemini AI"
    ],
    category: "ai agents",
    github: "https://github.com/amritrajrajput/Navigo-Bharat-AI-Agent",
    webapp: "",
    member: [],
  },
  {
    id: 4,
    title: "RailStay AI – Smart Retiring Room Finder 🚆",
    date: "May 2026 - Present",
    description:
      "An intelligent, agentic AI system that automates searching and ranking IRCTC retiring rooms. Built with LangGraph, Playwright, and Google's Gemini API, it dynamically plans searches, executes headless scraping in parallel, and ranks results based on user preferences.",
    image: "https://img.freepik.com/free-vector/train-station-concept-illustration_114360-15555.jpg",
    tags: [
      "Python",
      "Streamlit",
      "LangGraph",
      "Playwright",
      "Gemini API",
      "Agentic AI"
    ],
    category: "ai agents",
    github: "https://github.com/amritrajrajput/railstay-ai",
    webapp: "",
    member: [],
  },
  {
    id: 5,
    title: "Algerian Forest Fires Prediction 🌲",
    date: "2024",
    description:
      "A Machine Learning project that analyzes and predicts forest fire occurrences in Algeria based on meteorological and environmental data. It uses multiple regression techniques to identify critical factors influencing forest fires and provides a deployable Flask web application for real-time prediction.",
    image: "https://img.freepik.com/free-vector/forest-fire-concept-illustration_114360-6421.jpg?w=826&t=st=170845345~exp=170845405~hmac=a40498b826e7a221f1d1dc0f49cb8199b0c8b",
    tags: [
      "Machine Learning",
      "Python",
      "Flask",
      "Regression",
      "Data Analysis",
      "Predictive Modeling"
    ],
    category: "machine learning",
    github: "https://github.com/amritrajrajput/testforestfires",
    webapp: "",
    member: [],
  }
];

export const certifications = [
  {
    id: 0,
    title: "Oracle Cloud Infrastructure AI Foundations Associate",
    issuer: "Oracle",
    img: process.env.PUBLIC_URL + "/assets-port/others/oracle.png",
    link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=F6E097079A793C9C94D2F5BC961DEE570109A7D1F18B957709F6F6B69D0EA02F"
  },
  {
    id: 1,
    title: "Anthropic AI Fluency for Students",
    issuer: "Anthropic",
    img: "https://img.icons8.com/fluency/96/artificial-intelligence.png",
    link: "http://verify.skilljar.com/c/eqe673g6jzae"
  },
  {
    id: 2,
    title: "IBM Sustainability & Technology",
    issuer: "IBM",
    img: "https://img.icons8.com/color/96/ibm.png",
    link: "https://www.credly.com/badges/aca12845-c3e4-4062-a9c9-77ccea2ba6a9/linked_in_profile"
  },
  {
    id: 3,
    title: "Tata GenAI Data Analytics Simulation",
    issuer: "Tata",
    img: process.env.PUBLIC_URL + "/assets-port/others/tata.png",
    link: "https://www.theforage.com/completion-certificates/ifobHAoMjQs9s6bKS/gMTdCXwDdLYoXZ3wG_ifobHAoMjQs9s6bKS_KMbySJtMC69MTFiXf_1760753928855_completion_certificate.pdf"
  },
  {
    id: 4,
    title: "Tata Data Visualization",
    issuer: "Tata",
    img: process.env.PUBLIC_URL + "/assets-port/others/tata.png",
    link: "https://www.theforage.com/completion-certificates/ifobHAoMjQs9s6bKS/MyXvBcppsW2FkNYCX_ifobHAoMjQs9s6bKS_KMbySJtMC69MTFiXf_1760856036631_completion_certificate.pdf"
  },
  {
    id: 5,
    title: "Deloitte Data Analytics Simulation",
    issuer: "Deloitte",
    img: process.env.PUBLIC_URL + "/assets-port/others/delloite.png",
    link: "https://www.theforage.com/completion-certificates/9PBTqmSxAf6zZTseP/io9DzWKe3PTsiS6GG_9PBTqmSxAf6zZTseP_KMbySJtMC69MTFiXf_1760758649237_completion_certificate.pdf"
  },
  {
    id: 6,
    title: "British Airways Data Science Simulation",
    issuer: "British Airways",
    img: "https://img.icons8.com/color/96/british-airways.png",
    link: "https://www.theforage.com/completion-certificates/tMjbs76F526fF5v3G/NjynCWzGSaWXQCxSX_tMjbs76F526fF5v3G_KMbySJtMC69MTFiXf_1760797866341_completion_certificate.pdf"
  },
  {
    id: 7,
    title: "Postman API Fundamentals Student Expert",
    issuer: "Postman",
    img: process.env.PUBLIC_URL + "/assets-port/others/postman.png",
    link: "https://api.badgr.io/public/assertions/menu6YJTQM-qk6NxPF-86g"
  },
  {
    id: 8,
    title: "Hack2Skill GenAI Exchange Program",
    issuer: "Hack2Skill",
    img: "https://img.icons8.com/fluency/96/trophy.png",
    link: "https://certificate.hack2skill.com/user/GenAI5-28M/2025H2S04GENAI-A00731"
  },
  {
    id: 9,
    title: "Accenture Job Simulation",
    issuer: "Accenture",
    img: process.env.PUBLIC_URL + "/assets-port/others/accenture.png",
    link: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/T6kdcdKSTfg2aotxT/NqLZqrXRDvfkqHRKG_T6kdcdKSTfg2aotxT_KMbySJtMC69MTFiXf_1737742185217_completion_certificate.pdf"
  },
  {
    id: 10,
    title: "Gen AI LinkedIn Learning",
    issuer: "LinkedIn Learning",
    img: "https://img.icons8.com/color/96/linkedin.png",
    link: "https://www.linkedin.com/learning/certificates/ee52e351580fe02806b99e4fadbc15e98076661eded9a2e9735baa050840dd16/"
  },
  {
    id: 11,
    title: "Public Speaking",
    issuer: "Udemy",
    img: "https://img.icons8.com/color/96/udemy.png",
    link: "https://www.udemy.com/certificate/UC-77d3efd6-edb2-4057-8f39-d7fb8b777a4a/"
  }
];

{
  //   id: 3,
  //   title: "Fake News Detection using Machine Learning 📰",
  //   date: "Jun 2024 - Jul 2024",
  //   description:
  //     "Developed a fake news classifier using machine learning algorithms like Logistic Regression and Naive Bayes. The model analyzes news headlines and content to predict authenticity based on NLP techniques like TF-IDF.",
  //   image: "",
  //   tags: [
  //     "Machine Learning",
  //     "NLP",
  //     "Fake News Detection",
  //     "Scikit-learn",
  //     "Python",
  //     "TF-IDF",
  //     "Logistic Regression"
  //   ],
  //   category: "machine learning",
  //   github: "",
  //   webapp: "",
  //   member: [],
  // },
  // {
  //   id: 4,
  //   title: "Student Performance Predictor 📊",
  //   date: "May 2024 - Jun 2024",
  //   description:
  //     "Built a predictive model using supervised learning to estimate student academic performance based on study hours, parental education, and socioeconomic factors. Evaluated using RMSE and cross-validation.",
  //   image: "",
  //   tags: [
  //     "machine learning",
  //     "student performance",
  //     "regression",
  //     "pandas",
  //     "scikit-learn",
  //     "data visualization",
  //     "education analytics"
  //   ],
  //   category: "machine learning",
  //   github: "",
  //   webapp: "",
  //   member: [],
}
